import {baseRequestService} from "../../base.ts";

export const usersUserIdContactsContactIdDelete = (userId: number, contactId: string) =>
    baseRequestService({
        url: `/users/${userId}/contacts/${contactId}`,
        method: 'DELETE',
    })